<template>
    <div>
      <div class="whiteBox" style="display: flex;align-items: center;justify-content: space-between;">
        <div class="title ">{{ $t('view.企业认证') }}</div>
        <el-button style="min-width: 120px;" type="primary" v-if="enterpriseCategory==1" @click="changeEnterpriseCategoryNonIndonesian()">{{$t('view.转为国内供应商') }}</el-button>
      </div>
      <div class="whiteBox" v-if="enterpriseCategory!=1"> 
        <el-steps :active="active" align-center>
            <el-step :title="$t('view.填写企业信息')"></el-step>
            <el-step :title="$t('view.填写个人信息')"></el-step>
            <el-step :title="active==3&&!disabled?$t('view.信息审核驳回'): $t('view.信息审核中')"></el-step>
            <el-step :title="$t('view.身份认证通过')"></el-step>
        </el-steps>
      </div>
      <div class="whiteBox" v-if="enterpriseCategory!=1">
            <div v-show="active==1">
                <Information :disabled="disabled" :btnShow="btnDis!='modify'&&!disabled" :ChildForm="form" @nextStep="nextStep"></Information>
            </div>
            <div v-show="active==2">
                <Personal :disabled="disabled" :btnShow="btnDis!='modify'&&!disabled" :ChildForm="form" @nextStep="active=3;disabled=true" @PreviousStep="active-=1"></Personal>
            </div>
            <div v-show="active==3">
                 <el-form label-width="80px" v-if="!disabled">
                    <el-form-item :label="$t('view.驳回信息')">
                        <el-input type="textarea" :rows="3" style="width: 800px;" disabled v-model="feedback"></el-input>
                    </el-form-item>
                </el-form>
                <Information ref="Information" :disabled="disabled" :btnShow="btnDis!='modify'&&!disabled" :ChildForm="form" ></Information>
                <Personal ref="Personal" :disabled="disabled" :ChildForm="form" @nextStep="active=3;disabled=true"  :btnShow="btnDis!='modify'&&!disabled"></Personal>
                <!-- <div class="approvalComments">
                    <div class="title">驳回理由</div>
                    <div>{{ feedback }}</div>
                </div> -->
               
            </div>
            <div v-if="active==4">
                <Information :disabled="disabled" :ChildForm="form"></Information>
                <Personal :disabled="disabled" :ChildForm="form"></Personal>
            </div>
            
        <!-- <div style="text-align: center" v-if="btnDis!='prompt'&&btnDis!='skip'">
            <el-button style="min-width: 120px;" @click="authorizationAuthenticate" type="primary">{{ $t('view.提交') }}</el-button>
        </div> -->
      </div>
    </div>
  </template>
    
<script>
import {declareGetByUser,getAuthorization,authorizationVerify,changeEnterpriseCategoryNonIndonesian,authorizationDownLoad,getAuthorizationByRaxCode} from '@/api/project'
import Information from './Information.vue';
import Personal from './Personal.vue';
import {profileGetInfo} from '@/api/login'

  export default {
    components:{Information,Personal},
    data(){
      return{
        form:{
            businessLicenseFileList:[],
            agencyLicenseFileList:[],
            productionLicenseFileList:[],
            threeYearsFinancialReprotFileList:[],
            corporateIdCardFront:[],
            corporateIdCardOpposite:[],
            authorizationFileList:[],
        },    
        active:0,
        disabled:false,
        feedback:'',
        btnDis:'',
        enterpriseCategory:'',//是否为印尼供应商 1是
      }
    },
    created(){
        // 获取用户信息
        profileGetInfo().then(res=>{
            this.enterpriseCategory=res.data.enterpriseCategory
            if(this.enterpriseCategory!=1)
            this.authorizationVerify()
        }) 
        console.log('a',this.$store.getters)
    },
    methods:{
        chose(e){
            if(this.btnDis=='modify'||this.btnDis=='prompt')
            this.active=e
        },
        nextStep(e){
            this.form={...this.from,...e}
            this.active+=1
        },
        authorizationVerify(){
            authorizationVerify().then(res=>{
                this.btnDis=res.data.operation
                this.disabled=this.btnDis=='prompt'||this.btnDis=='skip'
                this.active=this.btnDis=='skip'?4:this.btnDis=='modify'?3:this.btnDis=='Auth'?1:3
                this.feedback=res.data.operationContent?res.data.operationContent:'信息正在审核中'
                if(this.btnDis=='Auth'){
                    this.getAuthorizationByRaxCode()
                }else{
                    this.getAuthorization()
                }
               
                // 审核中  审核通过 不可编辑
                // if(res.data.operation =='prompt' ||res.data.operation== 'skip')
            })
        },  
      
        changeEnterpriseCategoryNonIndonesian(){
            let that=this
            this.$confirm(this.$t('view.是否转为国内供应商'), that.$t('view.提示'), {
                confirmButtonText:that.$t('view.确定'),
                cancelButtonText: that.$t('view.取消'),
                type: 'warning'
            }).then(() => {
                changeEnterpriseCategoryNonIndonesian().then(res=>{
                    location.reload()
                })
            })
        },
        getAuthorizationByRaxCode(){
            getAuthorizationByRaxCode().then(res=>{
                if(res.data)
                this.form=res.data
                this.form.agencyLicenseFileList=this.form.agencyLicenseFileList?this.form.agencyLicenseFileList:[]
                this.form.productionLicenseFileList=this.form.productionLicenseFileList?this.form.productionLicenseFileList:[]
                this.form.threeYearsFinancialReprotFileList=this.form.threeYearsFinancialReprotFileList?this.form.threeYearsFinancialReprotFileList:[]
                this.form.corporateIdCardOpposite=this.form.corporateIdCardOpposite?this.form.corporateIdCardOpposite:[]
                this.form.corporateIdCardFront=this.form.corporateIdCardFront?this.form.corporateIdCardFront:[]
                this.form.authorizationFileList=this.form.authorizationFileList?this.form.authorizationFileList:[]
                this.form.businessLicenseFileList=this.form.businessLicenseFileList?this.form.businessLicenseFileList:[]
                // this.$set(this.form,'declareName',this.$store.getters.companyName)
                if(!this.form.name)
                this.$set(this.form,'name',this.$store.getters.name)
                this.form.mobile=this.$store.getters.phonenumber
                this.form.email=this.$store.getters.userEmail 
                this.$set(this.form,'typeAndBrand',this.form.typeAndBrand?JSON.parse(this.form.typeAndBrand):this.$store.getters.typeAndBrand? JSON.parse(this.$store.getters.typeAndBrand):[])
                if(!this.form.authorizationContactsList||this.form.authorizationContactsList.length==0)
                // this.$set(this.form,'authorizationContactsList',[{typeName:this.$t('view.单位管理人'),type:1},{typeName:this.$t('view.合同签订人'),type:2},{typeName:this.$t('view.采购业务员'),type:3}])
                this.$set(this.form,'authorizationContactsList',[])
                //this.form.bpmIdStr= '1798678076754890752,1798678266236768256'
                //this.form.bpmNameStr= '田涛,胡善鑫'
                if(this.btnDis=='Auth'){
                    this.form.isLegalRepresentative=''
                    this.form.authorizationEnd=''
                    this.form.authorizationStart=''
                    this.form.authorizationFileList=[]
                    this.form.id=null
                    this.form.instanceId=null
                    this.form.taskId=null
                    // this.form.sectionName=''
                   // this.form.bpmIdStr='' 
                    //this.form.bpmNameStr=''
                }
                this.form.enterpriseCategory=this.enterpriseCategory*1
            })
        },
        getAuthorization(){
            getAuthorization().then(res=>{
                if(res.data)
                this.form=res.data
                this.form.agencyLicenseFileList=this.form.agencyLicenseFileList?this.form.agencyLicenseFileList:[]
                this.form.productionLicenseFileList=this.form.productionLicenseFileList?this.form.productionLicenseFileList:[]
                this.form.threeYearsFinancialReprotFileList=this.form.threeYearsFinancialReprotFileList?this.form.threeYearsFinancialReprotFileList:[]
                this.form.corporateIdCardOpposite=this.form.corporateIdCardOpposite?this.form.corporateIdCardOpposite:[]
                this.form.corporateIdCardFront=this.form.corporateIdCardFront?this.form.corporateIdCardFront:[]
                this.form.authorizationFileList=this.form.authorizationFileList?this.form.authorizationFileList:[]
                this.form.businessLicenseFileList=this.form.businessLicenseFileList?this.form.businessLicenseFileList:[]
                // this.$set(this.form,'declareName',this.$store.getters.companyName)
                if(!this.form.name)
                this.$set(this.form,'name',this.$store.getters.name)
                this.form.mobile=this.$store.getters.phonenumber
                this.form.email=this.$store.getters.userEmail 
                this.$set(this.form,'typeAndBrand',this.form.typeAndBrand?JSON.parse(this.form.typeAndBrand):this.$store.getters.typeAndBrand? JSON.parse(this.$store.getters.typeAndBrand):[])
                if(!this.form.authorizationContactsList||this.form.authorizationContactsList.length==0)
                this.$set(this.form,'authorizationContactsList',[{typeName:this.$t('view.单位管理人'),type:1},{typeName:this.$t('view.合同签订人'),type:2},{typeName:this.$t('view.采购业务员'),type:3}])
                //this.form.bpmIdStr= '1798678076754890752,1798678266236768256'
                //this.form.bpmNameStr= '田涛,胡善鑫'
                if(this.btnDis=='Auth'){
                    this.form.isLegalRepresentative=''
                    this.form.authorizationEnd=''
                    this.form.authorizationStart=''
                    this.form.authorizationFileList=[]
                    this.form.id=null
                    this.form.instanceId=null
                    this.form.taskId=null
                    // this.form.sectionName=''
                   // this.form.bpmIdStr='' 
                    //this.form.bpmNameStr=''
                }
                this.form.enterpriseCategory=this.enterpriseCategory*1

            })
        },
    }
};
  </script>
  <style>
  .line20 .el-form-item__label{
    line-height: 20px !important;
  }
  </style>
  <style lang="scss" scoped>
  ::v-deep.hide .el-upload--picture-card {
    display: none;
  }
  ::v-deep.hide .el-upload--text{
      display: none;
  }
  .annexList{
      display: flex;
      margin-bottom: 20px;
      font-size: 14px;
      color: #303133;
      div:first-child{
          color: #909399;        
      }
  }
  .title{
      font-size: 16px;
      font-weight: 600;
      color: #333333;
  }
  .approvalComments{
    position: fixed;
    right: 10px;
    background: #fff;
    height: 200px;
    overflow-y: auto;
    padding: 20px;
    width: calc((100vw - 1400px) / 2);
    top: 370px;
  }
  </style>
   